import { jsx as m } from "react/jsx-runtime";
import { buyOffer as d } from "../../pages/checkout/api/index.mjs";
import { BadRequest as p, createHttpClient as w } from "@systemeio/util";
import { useStore as y } from "../../store/index.mjs";
import { twJoin as g } from "tailwind-merge";
import b from "../../ui-kit/theme-button.mjs";
const h = w();
async function R(r) {
  const t = await h.get(r, {
    maxRedirects: 0
    // Prevent axios from automatically following redirects
  });
  if (t.status === 200) {
    window.location.assign(t.data.options.paypalLink);
    return;
  }
  if (t.status >= 300 && t.status < 400) {
    const e = t.headers.location;
    if (e) {
      window.location.assign(e);
      return;
    }
  }
  throw new Error("No redirect URL found");
}
function L({
  isFetching: r,
  buttonTitle: t,
  buttonDisabled: e,
  setIsFetching: n,
  preSubmit: a,
  handleBadRequest: i,
  hasErrors: s
}) {
  const { locale: c } = y(), f = async (u) => {
    u.preventDefault(), n(!0);
    try {
      const o = a();
      if (!o) return;
      const { redirect: l } = await d(o, c);
      await R(l);
    } catch (o) {
      if (o instanceof p)
        i(o);
      else
        throw o;
    } finally {
      n(!1);
    }
  };
  return /* @__PURE__ */ m(
    b,
    {
      disabled: e,
      className: g("main-transition-colors", s && "bg-danger focus:bg-danger"),
      onClick: f,
      isFetching: r,
      type: "submit",
      children: t
    }
  );
}
export {
  L as PaypalRestPaymentButton,
  R as goToRedirect
};
